<!--LOADING-->
<ng-template [ngIf]="isLoading">
  <app-loading-page></app-loading-page>
</ng-template>
<!--END LOADING-->
<!--DASHBOARD PAGE-->

<!--MESSAGE INBOX-->
<ng-template [ngIf]="!isLoading">
  <section class="message-inbox">
    <div class="wrapper">
      <!--HEADING-->
      <h2 class="text-align-left margin-top-large margin-bottom-large">Message Center</h2>
      <!--END HEADING-->
      <!--MESSAGE CONTENT-->
      <ng-container *ngIf="expiredCertificates && expiredCertificates.length > 0; else noItems">
        <ul class="message">
          <!--NOTE: Inject expired certificates onto the page-->
          <!--NOTE: This outputs the certificates that are on the account, not expired ones, done for testing-->
          <li
            *ngFor="
              let expiredCertificate of expiredCertificates;
              let i = index;
              trackBy: trackByMessageInboxTitle
            ">
            <app-information-banner
              id="message-inbox-expired-certificate-{{ expiredCertificate.title }}"
              [icon]="'icon licensing medium red'"
              bodyText="Your Certificate {{ expiredCertificate.title }} will expire in {{
                expiredCertificate.expiryDueDate
              }} days."
              [actionLabel]="cardTypeCallToActions.LEARN_MORE"
              [route]="'certification/taking-a-certification-exam'"
              [routeType]="routeTypes.INTERNAL"
              [display]="true">
            </app-information-banner>
          </li>
        </ul>
      </ng-container>
      <!--END MESSAGE CONTENT-->
      <!--DEFAULT NO EXPIRED CERTIFICATIONS-->
      <ng-template #noItems>
        <ng-container *ngIf="messageInboxNoRecordsAnnouncement">
          <app-information-banner
            [icon]="messageInboxNoRecordsAnnouncement?.acf?.icon_class"
            [bodyText]="messageInboxNoRecordsAnnouncement?.acf?.short_description | safe : 'html'"
            [actionLabel]="cardTypeCallToActions.LEARN_MORE"
            [route]="messageInboxNoRecordsAnnouncement?.acf?.route_url"
            [routeType]="routeTypes.INTERNAL"
            [display]="messageInboxNoRecordsAnnouncement?.acf?.display_notification">
          </app-information-banner>
        </ng-container>
      </ng-template>
      <!--END DEFAULT NO EXPIRED CERTIFICATIONS-->
    </div>
  </section>
</ng-template>
<!--END MESSAGE INBOX-->
